import React from "react";
import editIcon from "../../../assets/images/icons/edit-sm-blue.png";
import fitpro from "../../../assets/images/fitpro.png";
import ActionButton from "../../../components/common/ActionBtn";
import { isValidImage } from "../../../utils/isValidImage";
import { ToogleField } from "../../../components/common/Toggle";
const MotivatonalManagerTable = ({
  header,
  plans,
  error,
  convertTimestamp,
  onEditClick,
  toggleStatus,
  handleDelete
}) => {
  const handleDownload = (plan) => {
    const jsonData = JSON.stringify(plan, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });
    const link = document.createElement("a");
    const fileName = `${plan.meditation_session.name.replace(/ /g, "_")}.json`;

    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="col-sm-12 workout-table-container">
      <div className="scrollable-table">
        <table
          className="table-custom"
          width="100%"
          cellPadding="0"
          cellSpacing="0"
        >
          <thead
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "#fff",
              zIndex: "1",
            }}
          >
            <tr>
              {header.map((heading, index) => (
                <th key={index} width={heading.width}>
                  {heading.label}
                </th>
              ))}
            </tr>
          </thead>
          {error ? (
            <tbody>
              <tr>
                <td colSpan={header.length}>
                  <p className="d-flex justify-content-center align-items-center">
                    {error}
                  </p>
                </td>
              </tr>
            </tbody>
          ) : plans.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan={header.length}>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          ) : (
            plans.map((plan,index) => {
              const statusClass = plan.status ? "active-btn" : "inactive-btn";
              return (
                <tbody key={`${plan.id}${index}`}>
                  <tr>
                    <td>{plan?.id}</td>
                    <td>
                      <div className="workout-sec  py-3">
                        <img
                          src={
                            isValidImage(
                              plan?.meditation_session?.cover_image_url ||
                                plan?.meditation_session?.thumbnail_image_url
                            )
                              ? plan?.meditation_session?.cover_image_url ||
                                plan?.meditation_session?.thumbnail_image_url
                              : fitpro
                          }
                          alt={plan.plan_name || "No image available"}
                          style={{
                            width: "180px",
                            height: "100px",
                            objectFit: "contain",
                            borderRadius: 10,
                          }}
                        />
                        <section className="px-4">
                          <h5>{plan?.meditation_session?.name}</h5>{" "}
                          <p style={{ color: "#667085" }}>
                            {plan?.meditation_session?.type}
                          </p>
                        </section>
                      </div>
                    </td>
                    <td>
                      <span className="date-upload">
                        {convertTimestamp(plan.createdAt?._seconds)}
                      </span>
                    </td>
                    <ToogleField  toggleStatus={toggleStatus} plan={plan} statusClass={statusClass}  />
                    <td>
                      <ActionButton
                        icon={editIcon}
                        onClick={() => onEditClick(plan.id)}
                        altText="Edit"
                        className="additional-class"
                      />
                      </td>
                      <td>
                      <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleDelete(plan.id)}
                  >
                    Delete
                  </button>
                    </td>
                    <td>
                      <button
                        className="btn  btn-outline-primary  d-flex align-items-center"
                        onClick={() => handleDownload(plan)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="16"
                          height="16"
                          style={{ marginRight: "5px" }}
                        >
                          <path d="M12 2a1 1 0 0 1 1 1v12.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L11 15.586V3a1 1 0 0 1 1-1zm-6 16a1 1 0 0 1 1 1v1h10v-1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              );
            })
          )}
        </table>
      </div>
    </div>
  );
};

export default MotivatonalManagerTable;
